/**
 * Attempts to parse a JSON string.
 *
 * If `value` is not valid JSON, the function returns the provided `fallback`
 * instead of throwing an error.
 *
 * @param {*} value - The value to parse (expected to be a JSON string).
 * @param {*} [fallback={}] - Value returned when parsing fails.
 * @returns {*} Parsed result or fallback.
 */
export const safeJsonParse = (value, fallback = {}) => {
  if (value == null || typeof value !== 'string') return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};
